
/* VitaPop PDP: 'Need more?' 3-pack add-on (v3, 2026-10-22).
   Owner: four options was confusing. The theme's own picker (one-time /
   subscribe) stays exactly as built; this adds ONE quiet secondary row
   beneath the buy form offering the 90-day pack as a one-time purchase.
   Prices: single parsed from the native picker (market-rounded), bundle
   from the product .js endpoint in the shopper's presentment currency. */
(function () {
  if (location.pathname.indexOf('/products/collagen-lollipops') === -1) return;
  if (location.pathname.indexOf('quarterly-bundle') !== -1) return;
  var BUNDLE_HANDLE = 'collagen-lollipops-quarterly-bundle-90';
  var BUNDLE_ID = 52698645168448;

  function fmt(cents) {
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'GBP';
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-GB',
        { style: 'currency', currency: cur }).format(cents / 100);
    } catch (e) { return cur + ' ' + (cents / 100).toFixed(2); }
  }
  function parseMoney(txt) {
    var m = (txt || '').replace(/[\s,]/g, '').match(/([0-9]+(?:\.[0-9]{1,2})?)/g);
    return m ? Math.round(parseFloat(m[m.length - 1]) * 100) : null;
  }

  function boot() {
    if (document.getElementById('vp-needmore')) return;
    var form = document.querySelector('main form[action*="/cart/add"], form[action*="/cart/add"]');
    if (!form) return;
    var oneTime = null;
    form.querySelectorAll('input[type="radio"]').forEach(function (r) {
      if (!/^\d+$/.test(r.value || '') && !oneTime) oneTime = r;
    });
    var lab = oneTime && (oneTime.closest('label') || oneTime.parentElement);
    var singleC = lab ? parseMoney(lab.textContent) : null;

    fetch('/products/' + BUNDLE_HANDLE + '.js')
      .then(function (r) { return r.json(); })
      .then(function (bp) {
        if (document.getElementById('vp-needmore')) return;
        var bundleC = bp.price;
        var save = singleC ? singleC * 3 - bundleC : 0;
        var css = ''
          + '#vp-needmore{margin:14px 0 0;border:1px dashed #d9c9ba;border-radius:12px;'
          + 'padding:12px 14px;display:flex;align-items:center;justify-content:space-between;'
          + 'gap:12px;background:#fdfaf6;flex-wrap:wrap}'
          + '#vp-needmore .nm-t{font-size:13.5px;color:#4a443e;line-height:1.45}'
          + '#vp-needmore .nm-t b{color:#2b2520}'
          + '#vp-needmore .nm-save{color:#b04a2e;font-weight:700}'
          + '#vp-needmore button{background:#fff;border:1.5px solid #ed7a5e;color:#c75234;'
          + 'font-weight:700;font-size:12.5px;border-radius:99px;padding:9px 16px;'
          + 'cursor:pointer;white-space:nowrap}'
          + '#vp-needmore button:hover{background:#ed7a5e;color:#fff}';
        var st = document.createElement('style'); st.textContent = css;
        document.head.appendChild(st);
        var el = document.createElement('div');
        el.id = 'vp-needmore';
        el.innerHTML = '<span class="nm-t"><b>Need more?</b> 3-pack (90 days), one-time '
          + '<b>' + fmt(bundleC) + '</b>'
          + (save > 0 ? ' <span class="nm-save">save ' + fmt(save) + '</span>' : '')
          + '</span><button type="button" id="vp-needmore-add">Add 3-pack</button>';
        form.insertAdjacentElement('afterend', el);
        document.getElementById('vp-needmore-add').addEventListener('click', function () {
          var b = this; b.disabled = true; b.textContent = 'Adding...';
          fetch('/cart/add.js', {
            method: 'POST', headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: BUNDLE_ID, quantity: 1 })
          }).then(function () { location.href = '/cart'; })
            .catch(function () { location.href = '/cart/add?id=' + BUNDLE_ID + '&quantity=1'; });
        });
      }).catch(function () {});
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
  [400, 1200, 2500].forEach(function (ms) { setTimeout(boot, ms); });
})();
